import styled from "styled-components";


export const Wrapper = styled.div`
position: fixed;
z-index: 1000;
width: 100%;
`